(function () {
  angular.module('binky.core.directory-sync', []);
})();
